import axios, { AxiosError } from 'axios';
import { XHR } from './interfaces';

export const ignoreRequestCancellationError = <T extends unknown = unknown>(error: AxiosError<XHR.RequestConfig>, returnValue?: T): T => {
  if (!axios.isCancel(error)) throw error;

  return returnValue;
};